/**
 * Test IDs for QA automation.
 */
export const testIds = {
  dwellTimeUpticksListCreate: "dwell-time-upticks-list-create",
} as const;
